import React, { useMemo } from 'react'
import styled from 'styled-components'
import { Button, Icon, LazyImg } from 'common/ui'
import MintBtn from './MintBtn'
import dayjs from 'dayjs'
import { toToken } from 'common/utils'
import { useCallback } from 'react'
import { makeTokenInfoUrl } from '../utils'
import { useRouter } from 'next/router'
import { DIOX } from 'common/api'
import clss from 'classnames'

const TokenCardStyled = styled.div`
  width: 652px;
  height: 249px;
  background: #1a1919;
  border: 1px solid #3a3939;
  border-radius: 12px;
  padding: 0 24px;
  margin-bottom: 24px;
  .card-header {
    height: 80px;
    display: flex;
    align-items: center;
    padding: 20px 0;
    position: relative;
    &:after {
      content: '';
      width: 100%;
      height: 1px;
      background: #3a3939;
      position: absolute;
      bottom: -0.5px;
      left: 0;
    }
    img {
      margin-right: 12px;
      width: 40px;
      height: 40px;
      border-radius: 100%;
    }
    .title {
      flex: 1;
      .name {
        font-weight: 500;
        font-size: 15px;
        line-height: 20px;
        color: #ffffff;
        margin-bottom: 4px;
      }
      .id {
        font-weight: 400;
        font-size: 13px;
        line-height: 15px;
        color: #a3a3a3;
      }
    }
    .mint {
      width: 88px;
      font-size: 15px;
      font-weight: 500;
    }
    .right-text {
      font-weight: 400;
      font-size: 15px;
      line-height: 20px;
      &.failed {
        color: #ec404e;
      }
      &.pending {
        color: #f78433;
      }
      &.confirmed {
        color: #00cc88;
      }
    }
  }
  .base-group {
    margin-top: 40px;
  }
  .detail-btn {
    font-size: 16px;
    .iconfont {
      font-size: 18px;
    }
    &:hover {
      background: rgba(224, 194, 134, 0.2);
    }
  }
`
type TokenCardProps = {
  data: DIOX.MyTokenBase
}
const TokenCard = ({ data }: TokenCardProps) => {
  const router = useRouter()

  const isFinalized = useMemo(() => {
    return data?.Status === 'Finalized'
  }, [data])

  const handleCardClick = useCallback(
    (e) => {
      if (data.Address && isFinalized) {
        router.push(makeTokenInfoUrl(data.Address))
      }
    },
    [data, router, isFinalized]
  )

  const renderRight = useMemo(() => {
    // const decimals = data.Decimals
    // const canMint = true // decimals << 22 !== data.Flags
    // if (data.ID && isFinalized && canMint) {
    //   return <MintBtn delegatee={data.Address} decimals={decimals} cvid={data.ID} />
    // }
    if (isFinalized) {
      return (
        <Button
          className="detail-btn"
          icon={'detail'}
          onClick={handleCardClick}
          type="outline"
          size="small"
        >
          Detail
        </Button>
      )
    }
    if (isFinalized) {
      return ''
    }
    return (
      <span className={clss(data.Status.toLowerCase(), 'right-text')}>
        {data.Status}
      </span>
    )
  }, [data, isFinalized, handleCardClick])

  return (
    <TokenCardStyled>
      <div className="card-header">
        <LazyImg
          url={data.IconUrl}
          defaultUrl="/img/default-token.png"
          alt="token-logo"
        />
        <div className="title">
          <p className="name">{data.Symbol}</p>
          {/* <p className="id"># {(isFinalized && data.ID) || '--'}</p> */}
        </div>
        {renderRight}
      </div>
      <div className="base-group">
        <div className="base-item">
          <Icon className="icon" type="decimals" />
          <span className="val">{data.Decimals || 0}</span>
          <p className="desc">Decimals</p>
        </div>
        <div className="base-item">
          <Icon className="icon" type="a-TotalSupply" />
          <span className="val line-clamp">
            {toToken({
              value: data.TotalSupply || 0,
              decimals: data.Decimals,
              isPretty: true,
            })}
          </span>
          <p className="desc">Total supply</p>
        </div>
        <div className="base-item">
          <Icon className="icon" type="a-createdate" />
          <span className="val">
            {dayjs(data.Time).format('MM/DD/YY HH:mm')}
          </span>
          <p className="desc">Creation date</p>
        </div>
      </div>
    </TokenCardStyled>
  )
}
export default TokenCard
